<template>
  <AppForm label="ユーザー属性設定">
    <v-btn @click="isActiveEditForm = true">変更</v-btn>
    <v-layout v-if="value.sex != null" class="pl-4">
      <v-flex xs2>
        <h4 class="left-title">性別</h4>
      </v-flex>
      <v-flex xs10>
        <DemographicChip :value="value.sex" @input="removeSex" />
      </v-flex>
    </v-layout>
    <v-layout v-if="value.age && value.age.length > 0" class="pl-4">
      <v-flex xs2>
        <h4 class="left-title">年代</h4>
      </v-flex>
      <v-flex xs10>
        <DemographicChip
          v-for="(a, index) in value.age"
          :key="index"
          :value="a"
          :index="index"
          @input="removeAge"
        />
      </v-flex>
    </v-layout>
    <v-layout v-if="value.marriage != null" class="pl-4">
      <v-flex xs2>
        <h4 class="left-title">婚姻関係</h4>
      </v-flex>
      <v-flex xs10>
        <DemographicChip :value="value.marriage" @input="removeMarriage" />
      </v-flex>
    </v-layout>
    <v-layout
      v-if="value.prefecture && value.prefecture.length !== 0"
      class="pl-4"
    >
      <v-flex xs2>
        <h4 class="left-title">居住地</h4>
      </v-flex>
      <v-flex xs10>
        <DemographicChip
          v-for="(p, index) in prefectureList"
          :key="index"
          :value="p.name"
          :index="index"
          @input="removePrefecture"
          display-value
        />
      </v-flex>
    </v-layout>
    <EditModal
      v-if="isActiveEditForm"
      v-model="isActiveEditForm"
      :settings="value"
      :hide-prefecture="hidePrefecture"
      :creative-type="creativeType"
      @change="$emit('input', $event)"
    />
  </AppForm>
</template>

<script>
import EditModal from '@/components/Shared/Common/FormAdvancedDemographicModalEdit'
import DemographicChip from '@/components/Shared/Common/FormAdvancedDemographicChip'
import { PrefectureModel } from '@/constants/prefecture'

export default {
  components: { EditModal, DemographicChip },
  props: {
    value: {
      //demographicSetting Model
      type: Object,
      default: () => {},
    },
    hidePrefecture: {
      type: Boolean,
      default: false,
    },
    creativeType: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      isActiveEditForm: false,
    }
  },
  computed: {
    prefectureList() {
      return this.value.prefecture.map(prefId => PrefectureModel.find(prefId))
    },
  },
  methods: {
    removeSex() {
      this.$emit('input', this.value.removeSex())
    },
    removeMarriage() {
      this.$emit('input', this.value.removeMarriage())
    },
    removeAge({ index }) {
      this.$emit('input', this.value.removeAge(index))
    },
    removePrefecture({ index }) {
      this.$emit('input', this.value.removePrefecture(index))
    },
  },
}
</script>

<style>
.left-title {
  line-height: 40px;
}
</style>
